import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenStorageService } from '../services/token-storage.service';

/** فقط کاربران لاگین‌شده با نقش Admin تایید‌شده (در پروفایل کش‌شده) اجازه ورود دارند */
export const adminAuthGuard: CanActivateFn = () => {
  const tokenStorage = inject(TokenStorageService);
  const router = inject(Router);

  if (tokenStorage.isAdminLoggedIn()) {
    return true;
  }

  tokenStorage.clear();
  router.navigateByUrl('/login');
  return false;
};

export const guestGuard: CanActivateFn = () => {
  const tokenStorage = inject(TokenStorageService);
  const router = inject(Router);

  if (!tokenStorage.isAdminLoggedIn()) {
    return true;
  }

  router.navigateByUrl('/dashboard');
  return false;
};
